import { makeStyles } from "@mui/styles";
import { View } from "../../Base";

const useStyles = makeStyles({
  container: {
    marginTop: "20px",
    display: "flex",
    flexDirection: "column",
    gap: "20px",
  },
  list: {
    display: "flex",
    flexDirection: "column",
    gap: "10px",
    marginTop: "0px",
    paddingLeft: "25px",
  },
});

export const DriversLockedContent = ({ error }) => {
  const styles = useStyles();

  return (
    <View className={styles.container}>
      <View>{error?.message || ""}</View>
      <View>To continue you will need to either</View>
      <ul className={styles.list}>
        <li>
          Select 'Force unlock', this will unlock all driver records in the
          depot
        </li>
        <li>Try again in a few minutes</li>
      </ul>
    </View>
  );
};
